import React, { useEffect } from "react";
import "./dopnft.scss";
import { useState } from "react";
import { Modal } from "react-bootstrap";
import NftPrice from "../../hooks/chinaFunction/nftprice";
import { event } from "jquery";
import { useWeb3React } from "@web3-react/core";
import { API_URL } from "../../utils/ApiUrl";
import axios from "axios";
import { toast } from "react-toastify";
import ApproveNft from "../../hooks/dataFetchers/ApproveNft";
import PurchaseNFTwithEth from "../../hooks/chinaFunction/purchaseNFTwithEth";
import PurchaseNFTwithUsdt from "../../hooks/chinaFunction/purchaseNFTwithUsdt";
import PurchaseNFTwithUsdc from "../../hooks/chinaFunction/puchaseNFTwithUsdc";
import PurchaseNFTwithWbtc from "../../hooks/chinaFunction/purchaseNFTwithWbtc";
import PurchaseNFTwithLink from "../../hooks/chinaFunction/purchaseNftwithLink";
import PurchaseNFTwithPepe from "../../hooks/chinaFunction/purchaseNftwithPepe";
import PurchaseNFTwithUniswape from "../../hooks/chinaFunction/purchaseNftwithUniswape";
import AllowanceNft from "../../hooks/dataFetchers/AllowanceNft";
import ApproveNftTomi from "../../hooks/dataFetchers/ApproveNftTomi";
import PurchaseNFTwithTomi from "../../hooks/chinaFunction/purchaseNftwithTomi";
import ApproveTpl from "../../hooks/dataFetchers/ApproveTpl";
import ApproveTomi from "../../hooks/dataFetchers/ApproveTomi";
import Environment from "../../utils/Environment";
import ApproveTplUsdc from "../../hooks/dataFetchers/ApproveTplUsdc";
import ApproveTplWbtc from "../../hooks/dataFetchers/ApproveTplWbtc";
import AllowanceWbtc from "../../hooks/dataFetchers/AllowanceWbtc";
import ApproveLink from "../../hooks/dataFetchers/ApproveLink";
import ApprovePepe from "../../hooks/dataFetchers/ApprovePepe";
import useWeb3 from "../../hooks/useWeb3";
import ApproveUnisawape from "../../hooks/dataFetchers/ApproveUniswape";
import AllowancePepe from "../../hooks/dataFetchers/AllowancePepe";
import ApproveDop from "../../hooks/dataFetchers/ApproveDop";
import PurchaseNFTwithDop from "../../hooks/chinaFunction/purchaseNftwithDop";
import { saveAddress } from "@sharemint/sdk";
import ApproveGems from "../../hooks/dataFetchers/ApproveGems";
import ApproveWeth from "../../hooks/dataFetchers/ApproveWeth";
import PurchaseNFTwithGems from "../../hooks/chinaFunction/purchaseNftwithGems";
import useRecordEvent from "../../hooks/useRecordEvent";
import { setupNetwork } from "../../utils/wallet";
import useWeb3ErrorToast, {
  generateToast,
} from "../../utils/useWeb3ErrorToast";
import { useHistory } from "react-router-dom";
import { notifyInfo } from "../Toast";
import PurchaseNFTwithWeth from "../../hooks/chinaFunction/purchaseNftwithWeth";
const CHAIN = process.env.REACT_APP_CHAIN_ID;

const DopNft = ({
  projectId,
  currentRount,
  email,
  timeshow,
  setShow,
  price,
  code,
  setLoarder,
  saleCurrentStaus,
  currentRoundd,
  discoundedPriceee,
  tab,
  stakeIndex,
  stakedAmount,
  discountedPriceee,
  round,
  insurancePer,
  checkBoxx,
  allowedTokens,
  selectedToken, //
  tagImge, //
  tokenConfig,
  tokenCache, //
  changeTag1, //
  fetchTokenData,
  getGasFeeInUSD,
  buyingNetworkFee,
  setbuyingNetworkFee,
  stakingData,
}) => {
  const Presale = Environment?.presale;
  const role = localStorage?.getItem("role_ins");
  let ipBuyer = localStorage.getItem("ip");
  let countryBuyer = localStorage.getItem("country");
  let sharemintValue = localStorage.getItem("sharemint");
  var now11 = new Date();
  let createdDate = now11?.getTime();
  let currentTime = createdDate / 1000;
  currentTime = parseInt(currentTime);

  const { recordEvent } = useRecordEvent();
  const { handleError } = useWeb3ErrorToast();
  const history = useHistory();

  //approve hooks
  const { approveWeth } = ApproveWeth();
  const { approveDop } = ApproveDop();
  const { approveLink } = ApproveLink();
  const { approvePepe } = ApprovePepe();
  const { approveUnisawape } = ApproveUnisawape();
  const { approveTomi } = ApproveTomi();
  const { approveGems } = ApproveGems();
  const { approveTpl } = ApproveTpl();
  const { approveTplUsdc } = ApproveTplUsdc();
  const { approveTplwbtc } = ApproveTplWbtc();
  const { approveNft } = ApproveNft();
  // const { approveNftTomi } = ApproveNftTomi();
  // const { allowanceNft } = AllowanceNft();
  //purchase hooks
  const { purchaseNFTwithWeth } = PurchaseNFTwithWeth();
  const { purchaseNFTwithDop } = PurchaseNFTwithDop();
  const { purchaseNFTwithUsdt } = PurchaseNFTwithUsdt();
  const { purchaseNFTwithEth } = PurchaseNFTwithEth();
  const { purchaseNFTwithTomi } = PurchaseNFTwithTomi();
  const { purchaseNFTwithGems } = PurchaseNFTwithGems();
  const { purchaseNFTwithUsdc } = PurchaseNFTwithUsdc();
  const { purchaseNFTwithWbtc } = PurchaseNFTwithWbtc();
  const { purchaseNFTwithLink } = PurchaseNFTwithLink();
  const { purchaseNFTwithUniswape } = PurchaseNFTwithUniswape();
  const { purchaseNFTwithPepe } = PurchaseNFTwithPepe();

  const [arryy, setArry] = useState([]);
  const [totalNFT, setTotalNft] = useState(0);
  const [totalClaim, setTotalClaim] = useState(0);
  const [totalUsdt, setUsdt] = useState(0);
  const [totalEth, setEth] = useState(0);
  const [totalWeth, setTotalWeth] = useState(0);
  const [totalTomi, setTomi] = useState(0);
  const [totalGems, setGems] = useState(0);
  const [totalUsdc, setUsdc] = useState(0);
  const [totalWbtc, setWbtc] = useState(0);
  const [totalUni, setUni] = useState(0);
  const [totalPepe, setPepe] = useState(0);
  const [totalLink, setLink] = useState(0);
  const [totalDop, setDop] = useState(0);
  const [check, setCheck] = useState(false);
  const { account, chainId } = useWeb3React();
  const [nftPriceArryUsdt, setNftPriceArryUsdt] = useState(0);
  const [nftPriceArryEth, setNftPriceArryEth] = useState([]);
  const [nftPriceArryIndux, setNftPriceArryIndux] = useState([]);
  const [totall, settTotal] = useState(0);
  const [totalleth, settTotaleth] = useState(0);

  // let imges = [
  //   { imge: "/nft-img/$500.png" },
  //   { imge: "/nft-img/$1000.png" },
  //   { imge: "/nft-img/$2000.png" },
  //   { imge: "/nft-img/$5000.png" },
  //   { imge: "/nft-img/$10000.png" },
  //   { imge: "/nft-img/$30000.png" },
  //   { imge: "/nft-img/$75000.png" },
  // ];

  const handleIncrement = (i) => {
    const newData = [...arryy];
    newData[i].count += 1;

    newData[i].dopClaim = (newData[i].usdtPrice * newData[i].count) / price;
    console.log(newData[i].dopClaim, "newData[i].dopClaim", price);
    setArry(newData);
    disableButtonCheck();
  };

  const handleDecrement = (i) => {
    const newData = [...arryy];

    if (newData[i].count > 0) {
      newData[i].count -= 1;
      newData[i].dopClaim = (newData[i].usdtPrice * newData[i].count) / price;
      setArry(newData);
    }

    disableButtonCheck();
  };

  const [show1, setShow1] = useState(false);
  const handleClose1 = () => setShow1(false);
  const handleShow1 = () => setShow1(true);

  const [show2, setShow2] = useState(false);
  const handleClose2 = () => {
    history.push("/claim/" + Presale?.symbol + "?buy=true");
    setShow2(false);
  };
  const handleShow2 = () => setShow2(true);

  const getTokenPrice = (symbol) => {
    return tokenCache?.[symbol]?.price || null;
  };

  const nftArry = async () => {
    let dummy = [];
    try {
      const nftsData = Presale?.nftDetails;
      for (let a = 0; a < nftsData.length; a++) {
        // let nftUsdPrice = await nftPrice(a);
        let nftUsdPrice = nftsData?.[a]?.price;

        const ethPrice = getTokenPrice("ETH");
        const wethPrice = getTokenPrice("WETH");
        const wbtcPrice = getTokenPrice("WBTC");
        const tomiPrice = getTokenPrice("TOMI");
        const linkPrice = getTokenPrice("LINK");
        const uniPrice = getTokenPrice("UNI");
        const pepePrice = getTokenPrice("PEPE");
        const dopPrice = getTokenPrice("DOP");
        const gemsPrice = getTokenPrice("GEMS");

        dummy.push({
          usdtPrice: nftUsdPrice,
          usdcPrice: nftUsdPrice,

          ethPrice: ethPrice ? nftUsdPrice / ethPrice : null,
          wethPrice: wethPrice ? nftUsdPrice / wethPrice : null,
          wbtcPrice: wbtcPrice ? nftUsdPrice / wbtcPrice : null,
          tomiPrice1: tomiPrice ? nftUsdPrice / tomiPrice : null,
          linkPrice: linkPrice ? nftUsdPrice / linkPrice : null,
          uniPrice: uniPrice ? nftUsdPrice / uniPrice : null,
          pepePrice1: pepePrice ? nftUsdPrice / pepePrice : null,
          dopPrice: dopPrice ? nftUsdPrice / dopPrice : null,
          gemsPrice1: gemsPrice ? nftUsdPrice / gemsPrice : null,

          imge: nftsData?.[a]?.image,
          count: 0,
          indexV: a,
          dopClaim: 0,
        });
      }
      setArry(dummy);
      // console.log(dummy,'dummy');
    } catch (err) {
      console.log(err, "err nooor");
    }
  };

  useEffect(() => {
    // Only need base price + at least one token price
    if (!Object.keys(tokenCache || {}).length) return;

    nftArry();
  }, [tokenCache, Presale]);

  useEffect(() => {
    clickMeAgain();
  }, [arryy]);
  const clickMe = () => {
    if (!navigator.onLine) {
      generateToast("RPC_FAIL");
      return;
    }
    let a = 0;
    let bb = 0;
    let cc = 0;
    let xx = 0;
    let xx1 = 0;
    let xx2 = 0;
    let xx3 = 0;
    let xx4 = 0;
    let xx5 = 0;
    let xx6 = 0;
    let xx7 = 0;
    let xx8 = 0;
    let xx9 = 0;
    let dun = [];
    let dun1 = [];
    let dun2 = [];
    arryy.map((e) => {
      a = e.count + a;
      bb = e?.dopClaim + bb;

      //    console.log(e.count,e?.ethPrice,cc,'e.count');
      if (e.count > 0) {
        cc = e?.usdtPrice * e.count + cc;
        xx = e?.ethPrice * e.count + xx;
        xx1 = e?.tomiPrice1 * e.count + xx1;
        xx2 = e?.usdcPrice * e.count + xx2;
        xx3 = e?.wbtcPrice * e.count + xx3;
        xx4 = e?.uniPrice * e.count + xx4;
        xx5 = e?.linkPrice * e.count + xx5;
        xx6 = e?.pepePrice1 * e.count + xx6;
        xx8 = e?.dopPrice * e.count + xx8;
        xx7 = e?.gemsPrice1 * e.count + xx7;
        xx9 = e?.wethPrice * e.count + xx9;
      }
      console.log(e.count * e?.dopPrice, "e.count * e?.dopPrice");
      dun.push(e.count * e?.usdtPrice);
      dun1.push(parseFloat(e.count * e?.ethPrice));
      dun2.push(e.count);
    });

    setGems(xx7);
    setTomi(xx1);
    setUni(xx4);
    setLink(xx5);
    setPepe(xx6);
    setDop(xx8);
    setUsdc(xx2);
    setWbtc(xx3);
    setTotalNft(a);
    setTotalClaim(bb);
    setEth(xx);
    setTotalWeth(xx9);
    setUsdt(cc);
    // setNftPriceArryEth(dun1);
    let totalSum = dun.reduce((a, b) => a + b, 0);
    setNftPriceArryUsdt(totalSum);
    setNftPriceArryIndux(dun2);
    // console.log(selectedToken, 'selectedToken');
    // if (selectedToken==="USDT"){
    let aa = cc;
    let vv = aa / discountedPriceee;
    let cccc = vv - parseFloat(bb)?.toFixed(2);
    // console.log(aa,vv,cccc,'sdssdsadas');
    settTotal(parseInt(cccc));
    let qq = cc * tokenCache?.["ETH"]?.price;
    let hh = qq / discountedPriceee;
    let nn = hh - parseFloat(bb)?.toFixed(2);
    // console.log(qq, nn, hh, 'sdssdsadas');
    // settTotaleth(parseInt(nn));
    // }

    handleShow1();
  };
  const clickMeAgain = () => {
    let a = 0;
    let bb = 0;
    let cc = 0;
    let xx = 0;
    let xx1 = 0;
    let xx2 = 0;
    let xx3 = 0;
    let xx4 = 0;
    let xx5 = 0;
    let xx6 = 0;
    let xx7 = 0;
    let xx8 = 0;
    let xx9 = 0;
    let dun = [];
    let dun1 = [];
    let dun2 = [];
    arryy.map((e) => {
      a = e.count + a;
      bb = e?.dopClaim + bb;

      //    console.log(e.count,e?.ethPrice,cc,'e.count');
      if (e.count > 0) {
        cc = e?.usdtPrice * e.count + cc;
        xx = e?.ethPrice * e.count + xx;
        xx1 = e?.tomiPrice1 * e.count + xx1;
        xx2 = e?.usdcPrice * e.count + xx2;
        xx3 = e?.wbtcPrice * e.count + xx3;
        xx4 = e?.uniPrice * e.count + xx4;
        xx5 = e?.linkPrice * e.count + xx5;
        xx6 = e?.pepePrice1 * e.count + xx6;
        xx8 = e?.dopPrice * e.count + xx8;
        xx7 = e?.gemsPrice1 * e.count + xx7;
        xx9 = e?.wethPrice * e.count + xx9;
      }
      dun.push(e.count * e?.usdtPrice);
      dun1.push(parseFloat(e.count * e?.ethPrice));
      dun2.push(e.count);
    });

    setGems(xx7);
    setTomi(xx1);
    setUni(xx4);
    setLink(xx5);
    setPepe(xx6);
    setDop(xx8);
    setUsdc(xx2);
    setWbtc(xx3);
    setTotalNft(a);
    setTotalClaim(bb);
    setEth(xx);
    setTotalWeth(xx9);
    setUsdt(cc);
    // setNftPriceArryEth(dun1);
    let totalSum = dun.reduce((a, b) => a + b, 0);
    setNftPriceArryUsdt(totalSum);
    setNftPriceArryIndux(dun2);
    // console.log(selectedToken, 'selectedToken');
    // if (selectedToken==="USDT"){
    let aa = cc;
    let vv = aa / discountedPriceee;
    let cccc = vv - parseFloat(bb)?.toFixed(2);
    // console.log(aa,vv,cccc,'sdssdsadas');
    settTotal(parseInt(cccc));
    let qq = cc * tokenCache?.["ETH"]?.price;
    let hh = qq / discountedPriceee;
    let nn = hh - parseFloat(bb)?.toFixed(2);
    // console.log(qq, nn, hh, 'sdssdsadas');
    // settTotaleth(parseInt(nn));
    // }
  };
  const disableButtonCheck = () => {
    let b = arryy.find((e) => e.count > 0);
    if (b) {
      setCheck(true);
    } else {
      setCheck(false);
    }
  };

  const submitt = async () => {
    setLoarder(true);
    if (chainId !== parseInt(CHAIN)) {
      await setupNetwork(CHAIN);
    }
    let config;
    let selectedTokenFromAllowed = allowedTokens.find(
      (t) => t.tokenSymbol === selectedToken,
    );
    handleClose1();
    confirmBuyBefore();
    config = {
      method: "post",
      url: `${API_URL}pro-projects/buy`,
      data: {
        accessCode: code,
        walletAddress: account.toString(),
        tokenSelected: selectedTokenFromAllowed?._id,
        project: projectId,
        type: "NFT",
        // country: countryBuyer,
        // email: email,
        // isInsured: checkBoxx,
      },
    };

    const postApiRes = await axios(config)
      .then(function (response) {
        return response?.data?.data;
      })
      .catch(function (error) {
        toast.error(error?.response?.data.message);
      });
    // console.log();
    let metaData = {};

    const balanceOfEth = tokenCache?.["ETH"]?.balance || 0;

    if (selectedToken === "USDT") {
      if (tokenCache?.[selectedToken]?.allowance === 0) {
        try {
          if (postApiRes) {
            if (saleCurrentStaus) {
              if (
                tokenCache?.[selectedToken]?.balance >=
                (checkBoxx
                  ? parseFloat(totalUsdt) + parseFloat(totalUsdt) * insurancePer
                  : totalUsdt)
              ) {
                let z = await approveTpl(10000000, account);
                if (z) {
                  let q = await purchaseNFTwithUsdt(
                    postApiRes,
                    currentRoundd,
                    nftPriceArryIndux,
                    price,
                    totalUsdt,
                    balanceOfEth,
                    stakeIndex,
                    checkBoxx,
                    insurancePer,
                  );
                  if (q) {
                    if (sharemintValue) {
                      saveAddress({
                        slug: "NFA",
                        transactionHash: q?.transactionHash,
                      });
                    }

                    await getGasFeeInUSD(q?.transactionHash);

                    metaData = {
                      transactionStatus: [
                        {
                          executed: true,
                          blockchainSuccess: true,
                          ex: "none",
                          transactionHash: q?.transactionHash,
                        },
                      ],
                    };

                    await callRecordEventTrxStatus(metaData);

                    confirmBuy(q);
                    handleShow2();
                    setLoarder(false);
                  }
                }
              } else {
                notifyInfo(
                  "Insufficient funds. You need additional funds to cover the price and network fees.",
                  "LOW_GAS",
                );
                setLoarder(false);
              }
            } else {
              toast.error("Sale is Currently Paused");
              setLoarder(false);
            }
          } else {
            setLoarder(false);
          }
        } catch (err) {
          console.log(err, "err");

          metaData = {
            transactionStatus: [
              {
                executed: false,
                blockchainSuccess: false,
                ex: "Transaction reverted",
                transactionHash: "none",
              },
            ],
          };

          await callRecordEventTrxStatus(metaData);

          handleError(err);
          fetchTokenData(selectedToken);
          fetchTokenData("ETH");
          setLoarder(false);
        }
      } else {
        try {
          if (totalUsdt > tokenCache?.[selectedToken]?.allowance) {
            if (postApiRes) {
              if (saleCurrentStaus) {
                if (
                  tokenCache?.[selectedToken]?.balance >=
                  (checkBoxx
                    ? parseFloat(totalUsdt) +
                      parseFloat(totalUsdt) * insurancePer
                    : totalUsdt)
                ) {
                  let res = await approveNft(0, account);
                  if (res) {
                    let res11 = await approveTpl(10000000, account);

                    if (res11) {
                      let q = await purchaseNFTwithUsdt(
                        postApiRes,
                        currentRoundd,
                        nftPriceArryIndux,
                        price,
                        totalUsdt,
                        balanceOfEth,
                        stakeIndex,
                        checkBoxx,
                        insurancePer,
                      );
                      if (q) {
                        saveAddress({
                          slug: "NFA",
                          transactionHash: q?.transactionHash,
                        });

                        await getGasFeeInUSD(q?.transactionHash);

                        metaData = {
                          transactionStatus: [
                            {
                              executed: true,
                              blockchainSuccess: true,
                              ex: "none",
                              transactionHash: q?.transactionHash,
                            },
                          ],
                        };

                        await callRecordEventTrxStatus(metaData);

                        confirmBuy(q);
                        handleShow2();
                        setLoarder(false);
                      }
                    }
                  }
                } else {
                  notifyInfo(
                    "Insufficient funds. You need additional funds to cover the price and network fees.",
                    "LOW_GAS",
                  );
                  setLoarder(false);
                }
              } else {
                toast.error("Sale is Currently Paused");
                setLoarder(false);
              }
            } else {
              setLoarder(false);
            }
          } else {
            if (postApiRes) {
              if (saleCurrentStaus) {
                if (
                  tokenCache?.[selectedToken]?.balance >=
                  (checkBoxx
                    ? parseFloat(totalUsdt) +
                      parseFloat(totalUsdt) * insurancePer
                    : totalUsdt)
                ) {
                  let q = await purchaseNFTwithUsdt(
                    postApiRes,
                    currentRoundd,
                    nftPriceArryIndux,
                    price,
                    totalUsdt,
                    balanceOfEth,
                    stakeIndex,
                    checkBoxx,
                    insurancePer,
                  );
                  if (q) {
                    saveAddress({
                      slug: "NFA",
                      transactionHash: q?.transactionHash,
                    });

                    await getGasFeeInUSD(q?.transactionHash);

                    metaData = {
                      transactionStatus: [
                        {
                          executed: true,
                          blockchainSuccess: true,
                          ex: "none",
                          transactionHash: q?.transactionHash,
                        },
                      ],
                    };

                    await callRecordEventTrxStatus(metaData);

                    confirmBuy(q);
                    handleShow2();
                    setLoarder(false);
                  }
                } else {
                  notifyInfo(
                    "Insufficient funds. You need additional funds to cover the price and network fees.",
                    "LOW_GAS",
                  );
                  setLoarder(false);
                }
              } else {
                toast.error("Sale is Currently Paused");
                setLoarder(false);
              }
            } else {
              setLoarder(false);
            }
          }
        } catch (err) {
          console.log(err, "errr");

          metaData = {
            transactionStatus: [
              {
                executed: false,
                blockchainSuccess: false,
                ex: "Transaction reverted",
                transactionHash: "none",
              },
            ],
          };

          await callRecordEventTrxStatus(metaData);

          fetchTokenData(selectedToken);
          fetchTokenData("ETH");
          handleError(err);
          setLoarder(false);

          // toast.error("Transaction reverted");
        }
      }
    } else if (selectedToken === "WETH") {
      if (tokenCache?.[selectedToken]?.allowance === 0) {
        try {
          if (postApiRes) {
            if (saleCurrentStaus) {
              if (
                tokenCache?.[selectedToken]?.balance >=
                (checkBoxx
                  ? parseFloat(totalWeth) + parseFloat(totalWeth) * insurancePer
                  : totalWeth)
              ) {
                let z = await approveWeth(10000000, account);
                if (z) {
                  let q = await purchaseNFTwithWeth(
                    postApiRes,
                    currentRoundd,
                    nftPriceArryIndux,
                    price,
                    totalUsdt,
                    balanceOfEth,
                    stakeIndex,
                    checkBoxx,
                    insurancePer,
                  );
                  if (q) {
                    saveAddress({
                      slug: "NFA",
                      transactionHash: q?.transactionHash,
                    });

                    await getGasFeeInUSD(q?.transactionHash);

                    metaData = {
                      transactionStatus: [
                        {
                          executed: true,
                          blockchainSuccess: true,
                          ex: "none",
                          transactionHash: q?.transactionHash,
                        },
                      ],
                    };

                    await callRecordEventTrxStatus(metaData);

                    confirmBuy(q);
                    handleShow2();
                    setLoarder(false);
                  }
                }
              } else {
                notifyInfo(
                  "Insufficient funds. You need additional funds to cover the price and network fees.",
                  "LOW_GAS",
                );
                setLoarder(false);
              }
            } else {
              toast.error("Sale is Currently Paused");
              setLoarder(false);
            }
          } else {
            setLoarder(false);
          }
        } catch (err) {
          console.log(err, "err");

          metaData = {
            transactionStatus: [
              {
                executed: false,
                blockchainSuccess: false,
                ex: "Transaction reverted",
                transactionHash: "none",
              },
            ],
          };

          await callRecordEventTrxStatus(metaData);

          handleError(err);
          fetchTokenData(selectedToken);
          fetchTokenData("ETH");
          setLoarder(false);
        }
      } else {
        try {
          if (totalWeth > tokenCache?.[selectedToken]?.allowance) {
            if (postApiRes) {
              if (saleCurrentStaus) {
                if (
                  tokenCache?.[selectedToken]?.balance >=
                  (checkBoxx
                    ? parseFloat(totalWeth) +
                      parseFloat(totalWeth) * insurancePer
                    : totalWeth)
                ) {
                  let res11 = await approveWeth(10000000, account);

                  if (res11) {
                    let q = await purchaseNFTwithWeth(
                      postApiRes,
                      currentRoundd,
                      nftPriceArryIndux,
                      price,
                      totalUsdt,
                      balanceOfEth,
                      stakeIndex,
                      checkBoxx,
                      insurancePer,
                    );
                    if (q) {
                      saveAddress({
                        slug: "NFA",
                        transactionHash: q?.transactionHash,
                      });

                      await getGasFeeInUSD(q?.transactionHash);

                      metaData = {
                        transactionStatus: [
                          {
                            executed: true,
                            blockchainSuccess: true,
                            ex: "none",
                            transactionHash: q?.transactionHash,
                          },
                        ],
                      };

                      await callRecordEventTrxStatus(metaData);

                      confirmBuy(q);
                      handleShow2();
                      setLoarder(false);
                    }
                  }
                } else {
                  notifyInfo(
                    "Insufficient funds. You need additional funds to cover the price and network fees.",
                    "LOW_GAS",
                  );
                  setLoarder(false);
                }
              } else {
                toast.error("Sale is Currently Paused");
                setLoarder(false);
              }
            } else {
              setLoarder(false);
            }
          } else {
            if (postApiRes) {
              if (saleCurrentStaus) {
                if (
                  tokenCache?.[selectedToken]?.balance >=
                  (checkBoxx
                    ? parseFloat(totalWeth) +
                      parseFloat(totalWeth) * insurancePer
                    : totalWeth)
                ) {
                  let q = await purchaseNFTwithWeth(
                    postApiRes,
                    currentRoundd,
                    nftPriceArryIndux,
                    price,
                    totalUsdt,
                    balanceOfEth,
                    stakeIndex,
                    checkBoxx,
                    insurancePer,
                  );
                  if (q) {
                    saveAddress({
                      slug: "NFA",
                      transactionHash: q?.transactionHash,
                    });

                    await getGasFeeInUSD(q?.transactionHash);

                    metaData = {
                      transactionStatus: [
                        {
                          executed: true,
                          blockchainSuccess: true,
                          ex: "none",
                          transactionHash: q?.transactionHash,
                        },
                      ],
                    };

                    await callRecordEventTrxStatus(metaData);

                    confirmBuy(q);
                    handleShow2();
                    setLoarder(false);
                  }
                } else {
                  notifyInfo(
                    "Insufficient funds. You need additional funds to cover the price and network fees.",
                    "LOW_GAS",
                  );
                  setLoarder(false);
                }
              } else {
                toast.error("Sale is Currently Paused");
                setLoarder(false);
              }
            } else {
              setLoarder(false);
            }
          }
        } catch (err) {
          console.log(err, "errr");

          metaData = {
            transactionStatus: [
              {
                executed: false,
                blockchainSuccess: false,
                ex: "Transaction reverted",
                transactionHash: "none",
              },
            ],
          };

          await callRecordEventTrxStatus(metaData);

          fetchTokenData(selectedToken);
          fetchTokenData("ETH");
          handleError(err);
          setLoarder(false);
        }
      }
    } else if (selectedToken === "USDC") {
      if (tokenCache?.[selectedToken]?.allowance === 0) {
        try {
          if (postApiRes) {
            if (saleCurrentStaus) {
              if (
                tokenCache?.[selectedToken]?.balance >=
                (checkBoxx
                  ? parseFloat(totalUsdc) + parseFloat(totalUsdc) * insurancePer
                  : totalUsdc)
              ) {
                let z = await approveTplUsdc(10000000, account);
                if (z) {
                  let q = await purchaseNFTwithUsdc(
                    postApiRes,
                    currentRoundd,
                    nftPriceArryIndux,
                    price,
                    totalUsdt,
                    balanceOfEth,
                    stakeIndex,
                    checkBoxx,
                    insurancePer,
                  );
                  if (q) {
                    saveAddress({
                      slug: "NFA",
                      transactionHash: q?.transactionHash,
                    });

                    await getGasFeeInUSD(q?.transactionHash);

                    metaData = {
                      transactionStatus: [
                        {
                          executed: true,
                          blockchainSuccess: true,
                          ex: "none",
                          transactionHash: q?.transactionHash,
                        },
                      ],
                    };

                    await callRecordEventTrxStatus(metaData);

                    confirmBuy(q);
                    handleShow2();
                    setLoarder(false);
                  }
                }
              } else {
                notifyInfo(
                  "Insufficient funds. You need additional funds to cover the price and network fees.",
                  "LOW_GAS",
                );
                setLoarder(false);
              }
            } else {
              toast.error("Sale is Currently Paused");
              setLoarder(false);
            }
          } else {
            setLoarder(false);
          }
        } catch (err) {
          console.log(err, "err");

          metaData = {
            transactionStatus: [
              {
                executed: false,
                blockchainSuccess: false,
                ex: "Transaction reverted",
                transactionHash: "none",
              },
            ],
          };

          await callRecordEventTrxStatus(metaData);

          handleError(err);
          fetchTokenData(selectedToken);
          fetchTokenData("ETH");
          setLoarder(false);
        }
      } else {
        try {
          if (totalUsdc > tokenCache?.[selectedToken]?.allowance) {
            if (postApiRes) {
              if (saleCurrentStaus) {
                if (
                  tokenCache?.[selectedToken]?.balance >=
                  (checkBoxx
                    ? parseFloat(totalUsdc) +
                      parseFloat(totalUsdc) * insurancePer
                    : totalUsdc)
                ) {
                  let res11 = await approveTplUsdc(10000000, account);

                  if (res11) {
                    let q = await purchaseNFTwithUsdc(
                      postApiRes,
                      currentRoundd,
                      nftPriceArryIndux,
                      price,
                      totalUsdt,
                      balanceOfEth,
                      stakeIndex,
                      checkBoxx,
                      insurancePer,
                    );
                    if (q) {
                      saveAddress({
                        slug: "NFA",
                        transactionHash: q?.transactionHash,
                      });

                      await getGasFeeInUSD(q?.transactionHash);

                      metaData = {
                        transactionStatus: [
                          {
                            executed: true,
                            blockchainSuccess: true,
                            ex: "none",
                            transactionHash: q?.transactionHash,
                          },
                        ],
                      };

                      await callRecordEventTrxStatus(metaData);

                      confirmBuy(q);
                      handleShow2();
                      setLoarder(false);
                    }
                  }
                } else {
                  notifyInfo(
                    "Insufficient funds. You need additional funds to cover the price and network fees.",
                    "LOW_GAS",
                  );
                  setLoarder(false);
                }
              } else {
                toast.error("Sale is Currently Paused");
                setLoarder(false);
              }
            } else {
              setLoarder(false);
            }
          } else {
            if (postApiRes) {
              if (saleCurrentStaus) {
                if (
                  tokenCache?.[selectedToken]?.balance >=
                  (checkBoxx
                    ? parseFloat(totalUsdc) +
                      parseFloat(totalUsdc) * insurancePer
                    : totalUsdc)
                ) {
                  let q = await purchaseNFTwithUsdc(
                    postApiRes,
                    currentRoundd,
                    nftPriceArryIndux,
                    price,
                    totalUsdt,
                    balanceOfEth,
                    stakeIndex,
                    checkBoxx,
                    insurancePer,
                  );
                  if (q) {
                    saveAddress({
                      slug: "NFA",
                      transactionHash: q?.transactionHash,
                    });

                    await getGasFeeInUSD(q?.transactionHash);

                    metaData = {
                      transactionStatus: [
                        {
                          executed: true,
                          blockchainSuccess: true,
                          ex: "none",
                          transactionHash: q?.transactionHash,
                        },
                      ],
                    };

                    await callRecordEventTrxStatus(metaData);

                    confirmBuy(q);
                    handleShow2();
                    setLoarder(false);
                  }
                } else {
                  notifyInfo(
                    "Insufficient funds. You need additional funds to cover the price and network fees.",
                    "LOW_GAS",
                  );
                  setLoarder(false);
                }
              } else {
                toast.error("Sale is Currently Paused");
                setLoarder(false);
              }
            } else {
              setLoarder(false);
            }
          }
        } catch (err) {
          console.log(err, "errr");

          metaData = {
            transactionStatus: [
              {
                executed: false,
                blockchainSuccess: false,
                ex: "Transaction reverted",
                transactionHash: "none",
              },
            ],
          };

          await callRecordEventTrxStatus(metaData);

          fetchTokenData(selectedToken);
          fetchTokenData("ETH");
          handleError(err);
          setLoarder(false);
        }
      }
    } else if (selectedToken === "WBTC") {
      // console.log(AllowanceWbtc,'AllowanceWbtc');
      if (tokenCache?.[selectedToken]?.allowance === 0) {
        try {
          if (postApiRes) {
            if (saleCurrentStaus) {
              if (
                tokenCache?.[selectedToken]?.balance >=
                (checkBoxx
                  ? parseFloat(totalWbtc) + parseFloat(totalWbtc) * insurancePer
                  : totalWbtc)
              ) {
                let z = await approveTplwbtc(10000000, account);
                if (z) {
                  let q = await purchaseNFTwithWbtc(
                    postApiRes,
                    currentRoundd,
                    nftPriceArryIndux,
                    price,
                    totalUsdt,
                    balanceOfEth,
                    stakeIndex,
                    checkBoxx,
                    insurancePer,
                  );
                  if (q) {
                    saveAddress({
                      slug: "NFA",
                      transactionHash: q?.transactionHash,
                    });

                    await getGasFeeInUSD(q?.transactionHash);

                    metaData = {
                      transactionStatus: [
                        {
                          executed: true,
                          blockchainSuccess: true,
                          ex: "none",
                          transactionHash: q?.transactionHash,
                        },
                      ],
                    };

                    await callRecordEventTrxStatus(metaData);

                    confirmBuy(q);
                    handleShow2();
                    setLoarder(false);
                  }
                }
              } else {
                notifyInfo(
                  "Insufficient funds. You need additional funds to cover the price and network fees.",
                  "LOW_GAS",
                );
                setLoarder(false);
              }
            } else {
              toast.error("Sale is Currently Paused");
              setLoarder(false);
            }
          } else {
            setLoarder(false);
          }
        } catch (err) {
          console.log(err, "err");

          metaData = {
            transactionStatus: [
              {
                executed: false,
                blockchainSuccess: false,
                ex: "Transaction reverted",
                transactionHash: "none",
              },
            ],
          };

          await callRecordEventTrxStatus(metaData);

          handleError(err);
          fetchTokenData(selectedToken);
          fetchTokenData("ETH");
          setLoarder(false);
        }
      } else {
        try {
          if (totalWbtc > tokenCache?.[selectedToken]?.allowance) {
            if (postApiRes) {
              if (saleCurrentStaus) {
                if (
                  tokenCache?.[selectedToken]?.balance >=
                  (checkBoxx
                    ? parseFloat(totalWbtc) +
                      parseFloat(totalWbtc) * insurancePer
                    : totalWbtc)
                ) {
                  let res11 = await approveTplwbtc(10000000, account);

                  if (res11) {
                    let q = await purchaseNFTwithWbtc(
                      postApiRes,
                      currentRoundd,
                      nftPriceArryIndux,
                      price,
                      totalUsdt,
                      balanceOfEth,
                      stakeIndex,
                      checkBoxx,
                      insurancePer,
                    );
                    if (q) {
                      saveAddress({
                        slug: "NFA",
                        transactionHash: q?.transactionHash,
                      });

                      await getGasFeeInUSD(q?.transactionHash);

                      metaData = {
                        transactionStatus: [
                          {
                            executed: true,
                            blockchainSuccess: true,
                            ex: "none",
                            transactionHash: q?.transactionHash,
                          },
                        ],
                      };

                      await callRecordEventTrxStatus(metaData);

                      confirmBuy(q);
                      handleShow2();
                      setLoarder(false);
                    }
                  }
                } else {
                  notifyInfo(
                    "Insufficient funds. You need additional funds to cover the price and network fees.",
                    "LOW_GAS",
                  );
                  setLoarder(false);
                }
              } else {
                toast.error("Sale is Currently Paused");
                setLoarder(false);
              }
            } else {
              setLoarder(false);
            }
          } else {
            if (postApiRes) {
              if (saleCurrentStaus) {
                if (
                  tokenCache?.[selectedToken]?.balance >=
                  (checkBoxx
                    ? parseFloat(totalWbtc) +
                      parseFloat(totalWbtc) * insurancePer
                    : totalWbtc)
                ) {
                  let q = await purchaseNFTwithWbtc(
                    postApiRes,
                    currentRoundd,
                    nftPriceArryIndux,
                    price,
                    totalUsdt,
                    balanceOfEth,
                    stakeIndex,
                    checkBoxx,
                    insurancePer,
                  );
                  if (q) {
                    saveAddress({
                      slug: "NFA",
                      transactionHash: q?.transactionHash,
                    });

                    await getGasFeeInUSD(q?.transactionHash);

                    metaData = {
                      transactionStatus: [
                        {
                          executed: true,
                          blockchainSuccess: true,
                          ex: "none",
                          transactionHash: q?.transactionHash,
                        },
                      ],
                    };

                    await callRecordEventTrxStatus(metaData);

                    confirmBuy(q);
                    handleShow2();
                    setLoarder(false);
                  }
                } else {
                  notifyInfo(
                    "Insufficient funds. You need additional funds to cover the price and network fees.",
                    "LOW_GAS",
                  );
                  setLoarder(false);
                }
              } else {
                toast.error("Sale is Currently Paused");
                setLoarder(false);
              }
            } else {
              setLoarder(false);
            }
          }
        } catch (err) {
          console.log(err, "errr");

          metaData = {
            transactionStatus: [
              {
                executed: false,
                blockchainSuccess: false,
                ex: "Transaction reverted",
                transactionHash: "none",
              },
            ],
          };

          await callRecordEventTrxStatus(metaData);

          fetchTokenData(selectedToken);
          fetchTokenData("ETH");
          handleError(err);
          setLoarder(false);
        }
      }
    } else if (selectedToken === "UNI") {
      if (tokenCache?.[selectedToken]?.allowance === 0) {
        try {
          if (postApiRes) {
            if (saleCurrentStaus) {
              if (
                tokenCache?.[selectedToken]?.balance >=
                (checkBoxx
                  ? parseFloat(totalUni) + parseFloat(totalUni) * insurancePer
                  : totalUni)
              ) {
                let z = await approveUnisawape(10000000, account);
                if (z) {
                  let q = await purchaseNFTwithUniswape(
                    postApiRes,
                    currentRoundd,
                    nftPriceArryIndux,
                    price,
                    totalUsdt,
                    balanceOfEth,
                    stakeIndex,
                    checkBoxx,
                    insurancePer,
                  );
                  if (q) {
                    saveAddress({
                      slug: "NFA",
                      transactionHash: q?.transactionHash,
                    });

                    await getGasFeeInUSD(q?.transactionHash);

                    metaData = {
                      transactionStatus: [
                        {
                          executed: true,
                          blockchainSuccess: true,
                          ex: "none",
                          transactionHash: q?.transactionHash,
                        },
                      ],
                    };

                    await callRecordEventTrxStatus(metaData);

                    confirmBuy(q);
                    handleShow2();
                    setLoarder(false);
                  }
                }
              } else {
                notifyInfo(
                  "Insufficient funds. You need additional funds to cover the price and network fees.",
                  "LOW_GAS",
                );
                setLoarder(false);
              }
            } else {
              toast.error("Sale is Currently Paused");
              setLoarder(false);
            }
          } else {
            setLoarder(false);
          }
        } catch (err) {
          metaData = {
            transactionStatus: [
              {
                executed: false,
                blockchainSuccess: false,
                ex: "Transaction reverted",
                transactionHash: "none",
              },
            ],
          };

          await callRecordEventTrxStatus(metaData);

          handleError(err);
          fetchTokenData(selectedToken);
          fetchTokenData("ETH");
          setLoarder(false);
        }
      } else {
        try {
          if (totalUni > tokenCache?.[selectedToken]?.allowance) {
            if (postApiRes) {
              if (saleCurrentStaus) {
                if (
                  tokenCache?.[selectedToken]?.balance >=
                  (checkBoxx
                    ? parseFloat(totalUni) + parseFloat(totalUni) * insurancePer
                    : totalUni)
                ) {
                  let res11 = await approveUnisawape(10000000, account);

                  if (res11) {
                    let q = await purchaseNFTwithUniswape(
                      postApiRes,
                      currentRoundd,
                      nftPriceArryIndux,
                      price,
                      totalUsdt,
                      balanceOfEth,
                      stakeIndex,
                      checkBoxx,
                      insurancePer,
                    );
                    if (q) {
                      saveAddress({
                        slug: "NFA",
                        transactionHash: q?.transactionHash,
                      });

                      await getGasFeeInUSD(q?.transactionHash);

                      metaData = {
                        transactionStatus: [
                          {
                            executed: true,
                            blockchainSuccess: true,
                            ex: "none",
                            transactionHash: q?.transactionHash,
                          },
                        ],
                      };

                      await callRecordEventTrxStatus(metaData);

                      confirmBuy(q);
                      handleShow2();
                      setLoarder(false);
                    }
                  }
                } else {
                  notifyInfo(
                    "Insufficient funds. You need additional funds to cover the price and network fees.",
                    "LOW_GAS",
                  );
                  setLoarder(false);
                }
              } else {
                toast.error("Sale is Currently Paused");
                setLoarder(false);
              }
            } else {
              setLoarder(false);
            }
          } else {
            if (postApiRes) {
              if (saleCurrentStaus) {
                if (
                  tokenCache?.[selectedToken]?.balance >=
                  (checkBoxx
                    ? parseFloat(totalUni) + parseFloat(totalUni) * insurancePer
                    : totalUni)
                ) {
                  let q = await purchaseNFTwithUniswape(
                    postApiRes,
                    currentRoundd,
                    nftPriceArryIndux,
                    price,
                    totalUsdt,
                    balanceOfEth,
                    stakeIndex,
                    checkBoxx,
                    insurancePer,
                  );
                  if (q) {
                    saveAddress({
                      slug: "NFA",
                      transactionHash: q?.transactionHash,
                    });

                    await getGasFeeInUSD(q?.transactionHash);

                    metaData = {
                      transactionStatus: [
                        {
                          executed: true,
                          blockchainSuccess: true,
                          ex: "none",
                          transactionHash: q?.transactionHash,
                        },
                      ],
                    };

                    await callRecordEventTrxStatus(metaData);

                    confirmBuy(q);
                    handleShow2();
                    setLoarder(false);
                  }
                } else {
                  notifyInfo(
                    "Insufficient funds. You need additional funds to cover the price and network fees.",
                    "LOW_GAS",
                  );
                  setLoarder(false);
                }
              } else {
                toast.error("Sale is Currently Paused");
                setLoarder(false);
              }
            } else {
              setLoarder(false);
            }
          }
        } catch (err) {
          console.log(err, "errr");
          metaData = {
            transactionStatus: [
              {
                executed: false,
                blockchainSuccess: false,
                ex: "Transaction reverted",
                transactionHash: "none",
              },
            ],
          };

          await callRecordEventTrxStatus(metaData);

          handleError(err);
          fetchTokenData(selectedToken);
          fetchTokenData("ETH");
          setLoarder(false);
        }
      }
    } else if (selectedToken === "LINK") {
      if (tokenCache?.[selectedToken]?.allowance === 0) {
        try {
          if (postApiRes) {
            if (saleCurrentStaus) {
              if (
                tokenCache?.[selectedToken]?.balance >=
                (checkBoxx
                  ? parseFloat(totalLink) + parseFloat(totalLink) * insurancePer
                  : totalLink)
              ) {
                let z = await approveLink(10000000, account);
                if (z) {
                  let q = await purchaseNFTwithLink(
                    postApiRes,
                    currentRoundd,
                    nftPriceArryIndux,
                    price,
                    totalUsdt,
                    balanceOfEth,
                    stakeIndex,
                    checkBoxx,
                    insurancePer,
                  );
                  if (q) {
                    saveAddress({
                      slug: "NFA",
                      transactionHash: q?.transactionHash,
                    });

                    await getGasFeeInUSD(q?.transactionHash);

                    metaData = {
                      transactionStatus: [
                        {
                          executed: true,
                          blockchainSuccess: true,
                          ex: "none",
                          transactionHash: q?.transactionHash,
                        },
                      ],
                    };

                    await callRecordEventTrxStatus(metaData);

                    confirmBuy(q);
                    handleShow2();
                    setLoarder(false);
                  }
                }
              } else {
                notifyInfo(
                  "Insufficient funds. You need additional funds to cover the price and network fees.",
                  "LOW_GAS",
                );
                setLoarder(false);
              }
            } else {
              toast.error("Sale is Currently Paused");
              setLoarder(false);
            }
          } else {
            setLoarder(false);
          }
        } catch (err) {
          console.log(err, "err");
          metaData = {
            transactionStatus: [
              {
                executed: false,
                blockchainSuccess: false,
                ex: "Transaction reverted",
                transactionHash: "none",
              },
            ],
          };

          await callRecordEventTrxStatus(metaData);

          handleError(err);
          fetchTokenData(selectedToken);
          fetchTokenData("ETH");
          setLoarder(false);
        }
      } else {
        try {
          if (totalLink > tokenCache?.[selectedToken]?.allowance) {
            if (postApiRes) {
              if (saleCurrentStaus) {
                if (
                  tokenCache?.[selectedToken]?.balance >=
                  (checkBoxx
                    ? parseFloat(totalLink) +
                      parseFloat(totalLink) * insurancePer
                    : totalLink)
                ) {
                  let res11 = await approveLink(10000000, account);

                  if (res11) {
                    let q = await purchaseNFTwithLink(
                      postApiRes,
                      currentRoundd,
                      nftPriceArryIndux,
                      price,
                      totalUsdt,
                      balanceOfEth,
                      stakeIndex,
                      checkBoxx,
                      insurancePer,
                    );
                    if (q) {
                      saveAddress({
                        slug: "NFA",
                        transactionHash: q?.transactionHash,
                      });

                      await getGasFeeInUSD(q?.transactionHash);

                      metaData = {
                        transactionStatus: [
                          {
                            executed: true,
                            blockchainSuccess: true,
                            ex: "none",
                            transactionHash: q?.transactionHash,
                          },
                        ],
                      };

                      await callRecordEventTrxStatus(metaData);

                      confirmBuy(q);
                      handleShow2();
                      setLoarder(false);
                    }
                  }
                } else {
                  notifyInfo(
                    "Insufficient funds. You need additional funds to cover the price and network fees.",
                    "LOW_GAS",
                  );
                  setLoarder(false);
                }
              } else {
                toast.error("Sale is Currently Paused");
                setLoarder(false);
              }
            } else {
              setLoarder(false);
            }
          } else {
            if (postApiRes) {
              if (saleCurrentStaus) {
                if (
                  tokenCache?.[selectedToken]?.balance >=
                  (checkBoxx
                    ? parseFloat(totalLink) +
                      parseFloat(totalLink) * insurancePer
                    : totalLink)
                ) {
                  let q = await purchaseNFTwithLink(
                    postApiRes,
                    currentRoundd,
                    nftPriceArryIndux,
                    price,
                    totalUsdt,
                    balanceOfEth,
                    stakeIndex,
                    checkBoxx,
                    insurancePer,
                  );
                  if (q) {
                    saveAddress({
                      slug: "NFA",
                      transactionHash: q?.transactionHash,
                    });

                    await getGasFeeInUSD(q?.transactionHash);

                    metaData = {
                      transactionStatus: [
                        {
                          executed: true,
                          blockchainSuccess: true,
                          ex: "none",
                          transactionHash: q?.transactionHash,
                        },
                      ],
                    };

                    await callRecordEventTrxStatus(metaData);

                    confirmBuy(q);
                    handleShow2();
                    setLoarder(false);
                  }
                } else {
                  notifyInfo(
                    "Insufficient funds. You need additional funds to cover the price and network fees.",
                    "LOW_GAS",
                  );
                  setLoarder(false);
                }
              } else {
                toast.error("Sale is Currently Paused");
                setLoarder(false);
              }
            } else {
              setLoarder(false);
            }
          }
        } catch (err) {
          console.log(err, "errr");
          metaData = {
            transactionStatus: [
              {
                executed: false,
                blockchainSuccess: false,
                ex: "Transaction reverted",
                transactionHash: "none",
              },
            ],
          };

          await callRecordEventTrxStatus(metaData);

          handleError(err);
          fetchTokenData(selectedToken);
          fetchTokenData("ETH");
          setLoarder(false);
        }
      }
    } else if (selectedToken === "DOP") {
      if (tokenCache?.[selectedToken]?.allowance === 0) {
        try {
          if (postApiRes) {
            if (saleCurrentStaus) {
              if (
                tokenCache?.[selectedToken]?.balance >=
                (checkBoxx
                  ? parseFloat(totalDop) + parseFloat(totalDop) * insurancePer
                  : totalDop)
              ) {
                let z = await approveDop(10000000, account);
                console.log(z, "zzzz");
                if (z) {
                  let q = await purchaseNFTwithDop(
                    postApiRes,
                    currentRoundd,
                    nftPriceArryIndux,
                    price,
                    totalUsdt,
                    balanceOfEth,
                    stakeIndex,
                    checkBoxx,
                    insurancePer,
                  );
                  if (q) {
                    saveAddress({
                      slug: "NFA",
                      transactionHash: q?.transactionHash,
                    });

                    await getGasFeeInUSD(q?.transactionHash);

                    metaData = {
                      transactionStatus: [
                        {
                          executed: true,
                          blockchainSuccess: true,
                          ex: "none",
                          transactionHash: q?.transactionHash,
                        },
                      ],
                    };

                    await callRecordEventTrxStatus(metaData);

                    confirmBuy(q);
                    handleShow2();
                    setLoarder(false);
                  }
                }
              } else {
                notifyInfo(
                  "Insufficient funds. You need additional funds to cover the price and network fees.",
                  "LOW_GAS",
                );
                setLoarder(false);
              }
            } else {
              toast.error("Sale is Currently Paused");
              setLoarder(false);
            }
          } else {
            setLoarder(false);
          }
        } catch (err) {
          console.log(err, "err");
          metaData = {
            transactionStatus: [
              {
                executed: false,
                blockchainSuccess: false,
                ex: "Transaction reverted",
                transactionHash: "none",
              },
            ],
          };

          await callRecordEventTrxStatus(metaData);

          handleError(err);
          fetchTokenData(selectedToken);
          fetchTokenData("ETH");
          setLoarder(false);
        }
      } else {
        try {
          if (totalDop > tokenCache?.[selectedToken]?.allowance) {
            if (postApiRes) {
              if (saleCurrentStaus) {
                if (
                  tokenCache?.[selectedToken]?.balance >=
                  (checkBoxx
                    ? parseFloat(totalDop) + parseFloat(totalDop) * insurancePer
                    : totalDop)
                ) {
                  let res11 = await approveDop(10000000, account);

                  if (res11) {
                    let q = await purchaseNFTwithDop(
                      postApiRes,
                      currentRoundd,
                      nftPriceArryIndux,
                      price,
                      totalUsdt,
                      balanceOfEth,
                      stakeIndex,
                      checkBoxx,
                      insurancePer,
                    );
                    if (q) {
                      saveAddress({
                        slug: "NFA",
                        transactionHash: q?.transactionHash,
                      });

                      await getGasFeeInUSD(q?.transactionHash);

                      metaData = {
                        transactionStatus: [
                          {
                            executed: true,
                            blockchainSuccess: true,
                            ex: "none",
                            transactionHash: q?.transactionHash,
                          },
                        ],
                      };

                      await callRecordEventTrxStatus(metaData);

                      confirmBuy(q);
                      handleShow2();
                      setLoarder(false);
                    }
                  }
                } else {
                  notifyInfo(
                    "Insufficient funds. You need additional funds to cover the price and network fees.",
                    "LOW_GAS",
                  );
                  setLoarder(false);
                }
              } else {
                toast.error("Sale is Currently Paused");
                setLoarder(false);
              }
            } else {
              setLoarder(false);
            }
          } else {
            if (postApiRes) {
              if (saleCurrentStaus) {
                if (
                  tokenCache?.[selectedToken]?.balance >=
                  (checkBoxx
                    ? parseFloat(totalDop) + parseFloat(totalDop) * insurancePer
                    : totalDop)
                ) {
                  let q = await purchaseNFTwithDop(
                    postApiRes,
                    currentRoundd,
                    nftPriceArryIndux,
                    price,
                    totalUsdt,
                    balanceOfEth,
                    stakeIndex,
                    checkBoxx,
                    insurancePer,
                  );
                  if (q) {
                    saveAddress({
                      slug: "NFA",
                      transactionHash: q?.transactionHash,
                    });

                    await getGasFeeInUSD(q?.transactionHash);

                    metaData = {
                      transactionStatus: [
                        {
                          executed: true,
                          blockchainSuccess: true,
                          ex: "none",
                          transactionHash: q?.transactionHash,
                        },
                      ],
                    };

                    await callRecordEventTrxStatus(metaData);

                    confirmBuy(q);
                    handleShow2();
                    setLoarder(false);
                  }
                } else {
                  notifyInfo(
                    "Insufficient funds. You need additional funds to cover the price and network fees.",
                    "LOW_GAS",
                  );
                  setLoarder(false);
                }
              } else {
                toast.error("Sale is Currently Paused");
                setLoarder(false);
              }
            } else {
              setLoarder(false);
            }
          }
        } catch (err) {
          console.log(err, "errr");
          metaData = {
            transactionStatus: [
              {
                executed: false,
                blockchainSuccess: false,
                ex: "Transaction reverted",
                transactionHash: "none",
              },
            ],
          };

          await callRecordEventTrxStatus(metaData);

          handleError(err);
          fetchTokenData(selectedToken);
          fetchTokenData("ETH");
          setLoarder(false);
        }
      }
    } else if (selectedToken === "PEPE") {
      if (tokenCache?.[selectedToken]?.allowance === 0) {
        try {
          if (postApiRes) {
            if (saleCurrentStaus) {
              if (
                tokenCache?.[selectedToken]?.balance >=
                (checkBoxx
                  ? parseFloat(totalPepe) + parseFloat(totalPepe) * insurancePer
                  : totalPepe)
              ) {
                let z = await approvePepe(10000000, account);
                if (z) {
                  let q = await purchaseNFTwithPepe(
                    postApiRes,
                    currentRoundd,
                    nftPriceArryIndux,
                    price,
                    totalUsdt,
                    balanceOfEth,
                    stakeIndex,
                    checkBoxx,
                    insurancePer,
                  );
                  if (q) {
                    saveAddress({
                      slug: "NFA",
                      transactionHash: q?.transactionHash,
                    });

                    await getGasFeeInUSD(q?.transactionHash);

                    metaData = {
                      transactionStatus: [
                        {
                          executed: true,
                          blockchainSuccess: true,
                          ex: "none",
                          transactionHash: q?.transactionHash,
                        },
                      ],
                    };

                    await callRecordEventTrxStatus(metaData);

                    confirmBuy(q);
                    handleShow2();
                    setLoarder(false);
                  }
                }
              } else {
                notifyInfo(
                  "Insufficient funds. You need additional funds to cover the price and network fees.",
                  "LOW_GAS",
                );
                setLoarder(false);
              }
            } else {
              toast.error("Sale is Currently Paused");
              setLoarder(false);
            }
          } else {
            setLoarder(false);
          }
        } catch (err) {
          console.log(err, "err");
          metaData = {
            transactionStatus: [
              {
                executed: false,
                blockchainSuccess: false,
                ex: "Transaction reverted",
                transactionHash: "none",
              },
            ],
          };

          await callRecordEventTrxStatus(metaData);

          handleError(err);
          fetchTokenData(selectedToken);
          fetchTokenData("ETH");
          setLoarder(false);
        }
      } else {
        try {
          if (totalPepe > tokenCache?.[selectedToken]?.allowance) {
            if (postApiRes) {
              if (saleCurrentStaus) {
                if (
                  tokenCache?.[selectedToken]?.balance >=
                  (checkBoxx
                    ? parseFloat(totalPepe) +
                      parseFloat(totalPepe) * insurancePer
                    : totalPepe)
                ) {
                  let res11 = await approvePepe(10000000, account);

                  if (res11) {
                    let q = await purchaseNFTwithPepe(
                      postApiRes,
                      currentRoundd,
                      nftPriceArryIndux,
                      price,
                      totalUsdt,
                      balanceOfEth,
                      stakeIndex,
                      checkBoxx,
                      insurancePer,
                    );
                    if (q) {
                      saveAddress({
                        slug: "NFA",
                        transactionHash: q?.transactionHash,
                      });

                      await getGasFeeInUSD(q?.transactionHash);

                      metaData = {
                        transactionStatus: [
                          {
                            executed: true,
                            blockchainSuccess: true,
                            ex: "none",
                            transactionHash: q?.transactionHash,
                          },
                        ],
                      };

                      await callRecordEventTrxStatus(metaData);

                      confirmBuy(q);
                      handleShow2();
                      setLoarder(false);
                    }
                  }
                } else {
                  notifyInfo(
                    "Insufficient funds. You need additional funds to cover the price and network fees.",
                    "LOW_GAS",
                  );
                  setLoarder(false);
                }
              } else {
                toast.error("Sale is Currently Paused");
                setLoarder(false);
              }
            } else {
              setLoarder(false);
            }
          } else {
            if (postApiRes) {
              if (saleCurrentStaus) {
                if (
                  tokenCache?.[selectedToken]?.balance >=
                  (checkBoxx
                    ? parseFloat(totalPepe) +
                      parseFloat(totalPepe) * insurancePer
                    : totalPepe)
                ) {
                  let q = await purchaseNFTwithPepe(
                    postApiRes,
                    currentRoundd,
                    nftPriceArryIndux,
                    price,
                    totalUsdt,
                    balanceOfEth,
                    stakeIndex,
                    checkBoxx,
                    insurancePer,
                  );
                  if (q) {
                    saveAddress({
                      slug: "NFA",
                      transactionHash: q?.transactionHash,
                    });

                    await getGasFeeInUSD(q?.transactionHash);

                    metaData = {
                      transactionStatus: [
                        {
                          executed: true,
                          blockchainSuccess: true,
                          ex: "none",
                          transactionHash: q?.transactionHash,
                        },
                      ],
                    };

                    await callRecordEventTrxStatus(metaData);

                    confirmBuy(q);
                    handleShow2();
                    setLoarder(false);
                  }
                } else {
                  notifyInfo(
                    "Insufficient funds. You need additional funds to cover the price and network fees.",
                    "LOW_GAS",
                  );
                  setLoarder(false);
                }
              } else {
                toast.error("Sale is Currently Paused");
                setLoarder(false);
              }
            } else {
              setLoarder(false);
            }
          }
        } catch (err) {
          console.log(err, "errr");
          metaData = {
            transactionStatus: [
              {
                executed: false,
                blockchainSuccess: false,
                ex: "Transaction reverted",
                transactionHash: "none",
              },
            ],
          };

          await callRecordEventTrxStatus(metaData);

          handleError(err);
          fetchTokenData(selectedToken);
          fetchTokenData("ETH");
          setLoarder(false);
        }
      }
    } else if (selectedToken === "ETH") {
      if (postApiRes) {
        if (saleCurrentStaus) {
          // console.log(blanceOfEth,totalEth,'khna',blanceOfEth<totalEth);
          if (
            balanceOfEth >
            (checkBoxx
              ? parseFloat(totalEth) + parseFloat(totalEth) * insurancePer
              : totalEth)
          ) {
            // console.log('in function call');
            try {
              let b = balanceOfEth - parseFloat(totalEth);
              let qw = await purchaseNFTwithEth(
                postApiRes,
                currentRoundd,
                nftPriceArryIndux,
                price,
                totalEth,
                b,
                stakeIndex,
                checkBoxx,
                insurancePer,
              );
              if (qw) {
                saveAddress({
                  slug: "NFA",
                  transactionHash: qw?.transactionHash,
                });

                await getGasFeeInUSD(qw?.transactionHash);

                metaData = {
                  transactionStatus: [
                    {
                      executed: true,
                      blockchainSuccess: true,
                      ex: "none",
                      transactionHash: qw?.transactionHash,
                    },
                  ],
                };

                await callRecordEventTrxStatus(metaData);

                confirmBuy(qw);
                handleShow2();
                setLoarder(false);
              }
            } catch (err) {
              console.log(err);

              metaData = {
                transactionStatus: [
                  {
                    executed: false,
                    blockchainSuccess: false,
                    ex: "Transaction reverted",
                    transactionHash: "none",
                  },
                ],
              };

              await callRecordEventTrxStatus(metaData);

              fetchTokenData("ETH");
              handleError(err);
              setLoarder(false);
            }
          } else {
            notifyInfo(
              "Insufficient funds. You need additional funds to cover the price and network fees.",
              "LOW_GAS",
            );
            setLoarder(false);
          }
        } else {
          toast.error("Sale is Currently Paused");
          setLoarder(false);
        }
      } else {
        console.log("api erro");
        setLoarder(false);
      }
    } else if (selectedToken === "TOMI") {
      if (tokenCache?.[selectedToken]?.allowance === 0) {
        try {
          if (postApiRes) {
            if (saleCurrentStaus) {
              if (
                tokenCache?.[selectedToken]?.balance >=
                (checkBoxx
                  ? parseFloat(totalTomi) + parseFloat(totalTomi) * insurancePer
                  : totalTomi)
              ) {
                let z = await approveTomi(10000000, account);
                if (z) {
                  let q = await purchaseNFTwithTomi(
                    postApiRes,
                    currentRoundd,
                    nftPriceArryIndux,
                    price,
                    totalUsdt,
                    balanceOfEth,
                    stakeIndex,
                    checkBoxx,
                    insurancePer,
                  );
                  if (q) {
                    saveAddress({
                      slug: "NFA",
                      transactionHash: q?.transactionHash,
                    });

                    await getGasFeeInUSD(q?.transactionHash);

                    metaData = {
                      transactionStatus: [
                        {
                          executed: true,
                          blockchainSuccess: true,
                          ex: "none",
                          transactionHash: q?.transactionHash,
                        },
                      ],
                    };

                    await callRecordEventTrxStatus(metaData);

                    confirmBuy(q);
                    handleShow2();
                    setLoarder(false);
                  }
                }
              } else {
                notifyInfo(
                  "Insufficient funds. You need additional funds to cover the price and network fees.",
                  "LOW_GAS",
                );
                setLoarder(false);
              }
            } else {
              toast.error("Sale is Currently Paused");
              setLoarder(false);
            }
          } else {
            setLoarder(false);
          }
        } catch (err) {
          console.log(err, "err");
          metaData = {
            transactionStatus: [
              {
                executed: false,
                blockchainSuccess: false,
                ex: "Transaction reverted",
                transactionHash: "none",
              },
            ],
          };

          await callRecordEventTrxStatus(metaData);

          handleError(err);
          fetchTokenData(selectedToken);
          fetchTokenData("ETH");
          setLoarder(false);
        }
      } else {
        try {
          if (totalTomi > tokenCache?.[selectedToken]?.allowance) {
            if (postApiRes) {
              if (saleCurrentStaus) {
                if (
                  tokenCache?.[selectedToken]?.balance >=
                  (checkBoxx
                    ? parseFloat(totalTomi) +
                      parseFloat(totalTomi) * insurancePer
                    : totalTomi)
                ) {
                  let res11 = await approveTomi(10000000, account);

                  if (res11) {
                    let q = await purchaseNFTwithTomi(
                      postApiRes,
                      currentRoundd,
                      nftPriceArryIndux,
                      price,
                      totalUsdt,
                      balanceOfEth,
                      stakeIndex,
                      checkBoxx,
                      insurancePer,
                    );
                    if (q) {
                      saveAddress({
                        slug: "NFA",
                        transactionHash: q?.transactionHash,
                      });

                      await getGasFeeInUSD(q?.transactionHash);

                      metaData = {
                        transactionStatus: [
                          {
                            executed: true,
                            blockchainSuccess: true,
                            ex: "none",
                            transactionHash: q?.transactionHash,
                          },
                        ],
                      };

                      await callRecordEventTrxStatus(metaData);

                      confirmBuy(q);
                      handleShow2();
                      setLoarder(false);
                    }
                  }
                } else {
                  notifyInfo(
                    "Insufficient funds. You need additional funds to cover the price and network fees.",
                    "LOW_GAS",
                  );
                  setLoarder(false);
                }
              } else {
                toast.error("Sale is Currently Paused");
                setLoarder(false);
              }
            } else {
              setLoarder(false);
            }
          } else {
            if (postApiRes) {
              if (saleCurrentStaus) {
                if (
                  tokenCache?.[selectedToken]?.balance >=
                  (checkBoxx
                    ? parseFloat(totalTomi) +
                      parseFloat(totalTomi) * insurancePer
                    : totalTomi)
                ) {
                  let q = await purchaseNFTwithTomi(
                    postApiRes,
                    currentRoundd,
                    nftPriceArryIndux,
                    price,
                    totalUsdt,
                    balanceOfEth,
                    stakeIndex,
                    checkBoxx,
                    insurancePer,
                  );
                  if (q) {
                    saveAddress({
                      slug: "NFA",
                      transactionHash: q?.transactionHash,
                    });

                    await getGasFeeInUSD(q?.transactionHash);

                    metaData = {
                      transactionStatus: [
                        {
                          executed: true,
                          blockchainSuccess: true,
                          ex: "none",
                          transactionHash: q?.transactionHash,
                        },
                      ],
                    };

                    await callRecordEventTrxStatus(metaData);

                    confirmBuy(q);
                    handleShow2();
                    setLoarder(false);
                  }
                } else {
                  notifyInfo(
                    "Insufficient funds. You need additional funds to cover the price and network fees.",
                    "LOW_GAS",
                  );
                  setLoarder(false);
                }
              } else {
                toast.error("Sale is Currently Paused");
                setLoarder(false);
              }
            } else {
              setLoarder(false);
            }
          }
        } catch (err) {
          console.log(err, "errr");
          metaData = {
            transactionStatus: [
              {
                executed: false,
                blockchainSuccess: false,
                ex: "Transaction reverted",
                transactionHash: "none",
              },
            ],
          };

          await callRecordEventTrxStatus(metaData);

          handleError(err);
          fetchTokenData(selectedToken);
          fetchTokenData("ETH");
          setLoarder(false);
        }
      }
    } else {
      if (tokenCache?.["GEMS"]?.allowance === 0) {
        try {
          if (postApiRes) {
            if (saleCurrentStaus) {
              if (
                tokenCache?.["GEMS"]?.balance >=
                (checkBoxx
                  ? parseFloat(totalGems) + parseFloat(totalGems) * insurancePer
                  : totalGems)
              ) {
                let z = await approveGems(10000000, account);
                if (z) {
                  let q = await purchaseNFTwithGems(
                    postApiRes,
                    currentRoundd,
                    nftPriceArryIndux,
                    price,
                    totalUsdt,
                    balanceOfEth,
                    stakeIndex,
                    checkBoxx,
                    insurancePer,
                  );
                  if (q) {
                    saveAddress({
                      slug: "NFA",
                      transactionHash: q?.transactionHash,
                    });

                    await getGasFeeInUSD(q?.transactionHash);

                    metaData = {
                      transactionStatus: [
                        {
                          executed: true,
                          blockchainSuccess: true,
                          ex: "none",
                          transactionHash: q?.transactionHash,
                        },
                      ],
                    };

                    await callRecordEventTrxStatus(metaData);

                    confirmBuy(q);
                    handleShow2();
                    setLoarder(false);
                  }
                }
              } else {
                notifyInfo(
                  "Insufficient funds. You need additional funds to cover the price and network fees.",
                  "LOW_GAS",
                );
                setLoarder(false);
              }
            } else {
              toast.error("Sale is Currently Paused");
              setLoarder(false);
            }
          } else {
            setLoarder(false);
          }
        } catch (err) {
          console.log(err, "err");

          metaData = {
            transactionStatus: [
              {
                executed: false,
                blockchainSuccess: false,
                ex: "Transaction reverted",
                transactionHash: "none",
              },
            ],
          };

          await callRecordEventTrxStatus(metaData);

          fetchTokenData(selectedToken);
          fetchTokenData("ETH");
          handleError(err);
          setLoarder(false);
        }
      } else {
        try {
          if (totalGems > tokenCache?.["GEMS"]?.allowance) {
            if (postApiRes) {
              if (saleCurrentStaus) {
                if (
                  tokenCache?.["GEMS"]?.balance >=
                  (checkBoxx
                    ? parseFloat(totalGems) +
                      parseFloat(totalGems) * insurancePer
                    : totalGems)
                ) {
                  let res11 = await approveGems(10000000, account);

                  if (res11) {
                    let q = await purchaseNFTwithGems(
                      postApiRes,
                      currentRoundd,
                      nftPriceArryIndux,
                      price,
                      totalUsdt,
                      balanceOfEth,
                      stakeIndex,
                      checkBoxx,
                      insurancePer,
                    );
                    if (q) {
                      saveAddress({
                        slug: "NFA",
                        transactionHash: q?.transactionHash,
                      });

                      await getGasFeeInUSD(q?.transactionHash);

                      metaData = {
                        transactionStatus: [
                          {
                            executed: true,
                            blockchainSuccess: true,
                            ex: "none",
                            transactionHash: q?.transactionHash,
                          },
                        ],
                      };

                      await callRecordEventTrxStatus(metaData);

                      confirmBuy(q);
                      handleShow2();
                      setLoarder(false);
                    }
                  }
                } else {
                  notifyInfo(
                    "Insufficient funds. You need additional funds to cover the price and network fees.",
                    "LOW_GAS",
                  );
                  setLoarder(false);
                }
              } else {
                toast.error("Sale is Currently Paused");
                setLoarder(false);
              }
            } else {
              setLoarder(false);
            }
          } else {
            if (postApiRes) {
              if (saleCurrentStaus) {
                if (
                  tokenCache?.["GEMS"]?.balance >=
                  (checkBoxx
                    ? parseFloat(totalGems) +
                      parseFloat(totalGems) * insurancePer
                    : totalGems)
                ) {
                  let q = await purchaseNFTwithGems(
                    postApiRes,
                    currentRoundd,
                    nftPriceArryIndux,
                    price,
                    totalUsdt,
                    balanceOfEth,
                    stakeIndex,
                    checkBoxx,
                    insurancePer,
                  );
                  if (q) {
                    saveAddress({
                      slug: "NFA",
                      transactionHash: q?.transactionHash,
                    });

                    await getGasFeeInUSD(q?.transactionHash);

                    metaData = {
                      transactionStatus: [
                        {
                          executed: true,
                          blockchainSuccess: true,
                          ex: "none",
                          transactionHash: q?.transactionHash,
                        },
                      ],
                    };

                    await callRecordEventTrxStatus(metaData);

                    confirmBuy(q);
                    handleShow2();
                    setLoarder(false);
                  }
                } else {
                  notifyInfo(
                    "Insufficient funds. You need additional funds to cover the price and network fees.",
                    "LOW_GAS",
                  );
                  setLoarder(false);
                }
              } else {
                toast.error("Sale is Currently Paused");
                setLoarder(false);
              }
            } else {
              setLoarder(false);
            }
          }
        } catch (err) {
          console.log(err, "errr");

          metaData = {
            transactionStatus: [
              {
                executed: false,
                blockchainSuccess: false,
                ex: "Transaction reverted",
                transactionHash: "none",
              },
            ],
          };

          await callRecordEventTrxStatus(metaData);

          fetchTokenData("GEMS");
          fetchTokenData("ETH");
          handleError(err);
          setLoarder(false);
        }
      }
    }
  };

  const callRecordEventTrxTrigger = async (metaData) => {
    await recordEvent(metaData);
  };

  const callRecordEventTrxStatus = async (metaData) => {
    await recordEvent(metaData);
  };

  const confirmBuy = async (dataaa) => {
    const tokenTotalsMap = {
      USDT: totalUsdt,
      WETH: totalWeth,
      ETH: totalEth,
      TOMI: totalTomi,
      USDC: totalUsdc,
      UNI: totalUni,
      LINK: totalLink,
      PEPE: totalPepe,
      DOP: totalDop,
      WBTC: totalWbtc,
      GEMS: totalGems, // fallback token
    };

    const baseAmount = tokenTotalsMap[selectedToken] ?? tokenTotalsMap.GEMS;

    const config = {
      method: "post",
      url: `${API_URL}emails`,
      data: {
        accessCode: code,
        transactionHash: dataaa?.transactionHash,
        accessCodeRole: role,
        by: account,
        recipient: account,
        price: stakingData ? discountedPriceee : price,
        recipientEmail: email,
        tokenSelected: selectedToken === "WETH" ? "ETH" : selectedToken,
        privateSale: Presale?.apiTag,
        ipAddress: ipBuyer,
        country: countryBuyer,
        dopPurchased: stakingData ? totalClaim + totall : totalClaim,
        isInsured: false,
        buyingAmount: checkBoxx
          ? (
              parseFloat(baseAmount) +
              parseFloat(baseAmount) * insurancePer
            ).toFixed(3)
          : parseFloat(baseAmount)?.toFixed(3),

        buyingAmountUsd: checkBoxx
          ? nftPriceArryUsdt + nftPriceArryUsdt * insurancePer
          : nftPriceArryUsdt,
      },
    };
    const postApiRes = await axios(config)
      .then(function (response) {
        // return response?.data?.data;
      })
      .catch(function (error) {
        // toast.error(error?.response?.data.message);
      });
  };
  const confirmBuyBefore = async () => {
    const config = {
      method: "post",
      url: `${API_URL}emails/temp`,
      data: {
        accessCode: code,
        accessCodeRole: role,
        by: account,
        price: stakingData ? discountedPriceee : price,
        recipientEmail: email,
        tokenSelected: selectedToken === "WETH" ? "ETH" : selectedToken,
        privateSale: Presale?.apiTag,
        ipAddress: ipBuyer,
        country: countryBuyer,
        isInsured: false,
      },
    };

    const totalsMap = {
      USDT: totalUsdt,
      WETH: totalWeth,
      ETH: totalEth,
      TOMI: totalTomi,
      USDC: totalUsdc,
      UNI: totalUni,
      LINK: totalLink,
      PEPE: totalPepe,
      DOP: totalDop,
      WBTC: totalWbtc,
      GEMS: totalGems,
    };
    const baseTotal = totalsMap[selectedToken] ?? totalGems;

    let metaData = {
      purchaseTxn: [
        {
          type: "NFT",
          amountInvested: 1.5,
          tokenSelected: selectedToken,
          tokensReceived: stakingData ? totalClaim + totall : totalClaim,
          dollarAmount: checkBoxx
            ? nftPriceArryUsdt + nftPriceArryUsdt * insurancePer
            : nftPriceArryUsdt,
          nft: (checkBoxx
            ? baseTotal + baseTotal * insurancePer
            : baseTotal
          ).toFixed(3),
        },
      ],
    };

    await callRecordEventTrxTrigger(metaData);

    const postApiRes = await axios(config)
      .then(function (response) {
        // return response?.data?.data;
      })
      .catch(function (error) {
        // toast.error(error?.response?.data.message);
      });
  };

  console.log("array nft", arryy);

  return (
    <>
      <section className="dop_nft">
        <div class="dropdown select-drop">
          <button
            class="dropdown-toggle"
            type="button"
            data-toggle="dropdown"
            aria-expanded="false"
          >
            <div className="twice">
              <div className="inner-flex">
                <img
                  style={{ width: "18px", height: "18px", objectFit: "cover" }}
                  src={tagImge}
                  alt="img"
                  className="img-fluid"
                />{" "}
                {selectedToken}
              </div>
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="15"
                height="8"
                viewBox="0 0 15 8"
                fill="none"
              >
                <path
                  d="M0.535156 0.5L0.535157 3.47056L7.76848 7.5L7.76848 4.52943L0.535156 0.5Z"
                  fill="#02171D"
                />
                <path
                  d="M15 0.500244L15 3.47081L7.76667 7.50024L7.76667 4.52968L15 0.500244Z"
                  fill="#02171D"
                />
              </svg>
            </div>
          </button>
          <ul class="dropdown-menu">
            {allowedTokens?.map((token) => (
              <li key={token.tokenSymbol}>
                <a
                  className="dropdown-item gscrxcsx"
                  onClick={() => changeTag1(token.tokenSymbol)}
                >
                  <img
                    src={
                      tokenConfig[token.tokenSymbol]?.image ||
                      token?.imageUrl ||
                      "/assets/default.svg"
                    }
                    alt={token.tokenSymbol}
                    className="img-fluid"
                  />{" "}
                  {token.tokenSymbol}
                </a>
              </li>
            ))}
          </ul>
        </div>
        <div className="parent-card">
          {arryy?.map((e, i) => {
            return (
              <div className="inner-card">
                <div className="upper-img">
                  <img src={e?.imge} alt="img" className="img-fluid" />
                </div>
                <div className="bottom-text">
                  <div className="inner-text">
                    <p>Price {selectedToken}</p>
                    <h6>
                      {selectedToken === "USDT" ? "$" : ""}
                      {selectedToken === "USDT"
                        ? e?.usdtPrice
                        : selectedToken === "ETH"
                          ? parseFloat(e?.ethPrice).toFixed(4)
                          : selectedToken === "WETH"
                            ? parseFloat(e?.wethPrice).toFixed(4)
                            : selectedToken === "TOMI"
                              ? parseFloat(e?.tomiPrice1).toFixed(4)
                              : selectedToken === "USDC"
                                ? parseFloat(e?.usdcPrice).toFixed(4)
                                : selectedToken === "UNI"
                                  ? parseFloat(e?.uniPrice).toFixed(4)
                                  : selectedToken === "LINK"
                                    ? parseFloat(e?.linkPrice).toFixed(4)
                                    : selectedToken === "PEPE"
                                      ? parseFloat(e?.pepePrice1).toFixed(4)
                                      : selectedToken === "DOP"
                                        ? parseFloat(e?.dopPrice).toFixed(4)
                                        : selectedToken === "WBTC"
                                          ? parseFloat(e?.wbtcPrice).toFixed(4)
                                          : parseFloat(e?.gemsPrice1).toFixed(
                                              4,
                                            )}
                    </h6>
                  </div>
                  <div className="inner-text">
                    <p>Claimable ${Presale?.symbol}</p>
                    <h6>{parseFloat(e?.dopClaim).toFixed(4)}</h6>
                  </div>
                </div>
                <div className="select-nft">
                  <div className="left">
                    {e?.count == 0 ? (
                      <img
                        src="\assets\minusnft.svg"
                        alt="img"
                        className="img-fluid"
                        style={{ opacity: "0.2", pointerEvents: "none" }}
                      />
                    ) : (
                      <img
                        onClick={(event) => handleDecrement(i)}
                        src="\assets\minusnft.svg"
                        alt="img"
                        className="img-fluid"
                      />
                    )}
                  </div>
                  <div className="mid">
                    <h6>{e?.count}</h6>
                  </div>
                  <div className="right">
                    <img
                      onClick={(event) => handleIncrement(i)}
                      src="\assets\plusnft.svg"
                      alt="img"
                      className="img-fluid"
                    />
                  </div>
                </div>
              </div>
            );
          })}
        </div>
        <div
          className="inner-text-bold mt-3 w-100"
          style={{ flexDirection: "column" }}
        >
          {checkBoxx && (
            <div
              style={{
                display: "flex",
                justifyContent: "space-between",
                alignItems: "center",
              }}
              className="w-100 mb-3"
            >
              <h6 style={{ color: "#329879" }}>Gems Protect</h6>
              <h6>
                {selectedToken === "USDT"
                  ? parseFloat(totalUsdt * insurancePer)?.toFixed(3)
                  : selectedToken === "ETH"
                    ? parseFloat(totalEth * insurancePer)?.toFixed(3)
                    : selectedToken === "WETH"
                      ? parseFloat(totalWeth * insurancePer)?.toFixed(3)
                      : selectedToken === "TOMI"
                        ? parseFloat(totalTomi * insurancePer)?.toFixed(3)
                        : selectedToken === "USDC"
                          ? parseFloat(totalUsdc * insurancePer)?.toFixed(3)
                          : selectedToken === "UNI"
                            ? parseFloat(totalUni * insurancePer)?.toFixed(3)
                            : selectedToken === "LINK"
                              ? parseFloat(totalLink * insurancePer)?.toFixed(3)
                              : selectedToken === "PEPE"
                                ? parseFloat(totalPepe * insurancePer)?.toFixed(
                                    3,
                                  )
                                : selectedToken === "DOP"
                                  ? parseFloat(
                                      totalDop * insurancePer,
                                    )?.toFixed(3)
                                  : selectedToken === "WBTC"
                                    ? parseFloat(
                                        totalWbtc * insurancePer,
                                      )?.toFixed(3)
                                    : parseFloat(
                                        totalGems * insurancePer,
                                      )?.toFixed(3)}{" "}
                <span> {selectedToken}</span>{" "}
                <span style={{ fontSize: "18px", color: "#77868B" }}>
                  ($
                  {check
                    ? (nftPriceArryUsdt * insurancePer)?.toLocaleString(
                        undefined,
                        {
                          minimumFractionDigits: 0,
                          maximumFractionDigits: 5,
                        },
                      )
                    : 0.0}
                  )
                </span>
              </h6>
            </div>
          )}
          <div
            style={{
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center",
            }}
            className="w-100"
          >
            <h6 style={{ color: "#329879" }}>Total:</h6>
            <h6>
              <span style={{ color: "#329879" }}>
                {selectedToken === "USDT"
                  ? checkBoxx
                    ? parseFloat(
                        parseFloat(totalUsdt) + totalUsdt * insurancePer,
                      )?.toFixed(3)
                    : totalUsdt
                  : selectedToken === "ETH"
                    ? checkBoxx
                      ? parseFloat(
                          parseFloat(totalEth) + totalEth * insurancePer,
                        )?.toFixed(3)
                      : totalEth?.toFixed(3)
                    : selectedToken === "WETH"
                      ? checkBoxx
                        ? parseFloat(
                            parseFloat(totalWeth) + totalWeth * insurancePer,
                          )?.toFixed(3)
                        : totalWeth?.toFixed(3)
                      : selectedToken === "TOMI"
                        ? checkBoxx
                          ? parseFloat(
                              parseFloat(totalTomi) + totalTomi * insurancePer,
                            )?.toFixed(3)
                          : totalTomi?.toFixed(3)
                        : selectedToken === "USDC"
                          ? checkBoxx
                            ? parseFloat(
                                parseFloat(totalUsdc) +
                                  totalUsdc * insurancePer,
                              )?.toFixed(3)
                            : totalUsdc?.toFixed(3)
                          : selectedToken === "UNI"
                            ? checkBoxx
                              ? parseFloat(
                                  parseFloat(totalUni) +
                                    totalUni * insurancePer,
                                )?.toFixed(3)
                              : totalUni?.toFixed(3)
                            : selectedToken === "LINK"
                              ? checkBoxx
                                ? parseFloat(
                                    parseFloat(totalLink) +
                                      totalLink * insurancePer,
                                  )?.toFixed(3)
                                : totalLink?.toFixed(3)
                              : selectedToken === "PEPE"
                                ? checkBoxx
                                  ? parseFloat(
                                      parseFloat(totalPepe) +
                                        totalPepe * insurancePer,
                                    )?.toFixed(3)
                                  : totalPepe?.toFixed(3)
                                : selectedToken === "DOP"
                                  ? checkBoxx
                                    ? parseFloat(
                                        parseFloat(totalDop) +
                                          totalDop * insurancePer,
                                      )?.toFixed(3)
                                    : totalDop?.toFixed(3)
                                  : selectedToken === "WBTC"
                                    ? checkBoxx
                                      ? parseFloat(
                                          parseFloat(totalWbtc) +
                                            totalWbtc * insurancePer,
                                        )?.toFixed(3)
                                      : totalWbtc?.toFixed(3)
                                    : checkBoxx
                                      ? parseFloat(
                                          parseFloat(totalGems) +
                                            totalGems * insurancePer,
                                        )?.toFixed(3)
                                      : totalGems?.toFixed(3)}
              </span>{" "}
              <span style={{ color: "#329879" }}> {selectedToken}</span>{" "}
              <span style={{ fontSize: "18px", color: "#77868B" }}>
                ($
                {check ? (
                  <>
                    {checkBoxx
                      ? (
                          nftPriceArryUsdt +
                          nftPriceArryUsdt * insurancePer
                        )?.toLocaleString(undefined, {
                          minimumFractionDigits: 0,
                          maximumFractionDigits: 5,
                        })
                      : nftPriceArryUsdt?.toLocaleString(undefined, {
                          minimumFractionDigits: 0,
                          maximumFractionDigits: 5,
                        })}
                  </>
                ) : (
                  0.0
                )}
                )
              </span>
            </h6>
          </div>
        </div>

        <div className="bottom-btn">
          {account ? (
            <>
              {!timeshow &&
              currentTime > new Date(parseInt(currentRount?.startTime)) &&
              currentTime < new Date(parseInt(currentRount?.endTime)) ? (
                <>
                  {check ? (
                    <button onClick={clickMe} className="btn-buy-nft">
                      Buy NFTs
                    </button>
                  ) : (
                    <button className="btn-buy">Buy NFTs</button>
                  )}
                </>
              ) : (
                <button className="btn-buy">Buy NFTs</button>
              )}
            </>
          ) : (
            <button className="btn-buy">Buy NFTs</button>
          )}

          {/* </>
            :
            <button onClick={() => {
              setShow(true)
            }} className="btn-buy">Buy NFTs</button>
          } */}
        </div>
      </section>

      <Modal
        className="connectwallet-modal"
        show={show1}
        onHide={handleClose1}
        centered
      >
        <Modal.Header closeButton>
          <Modal.Title>Buy NFTs</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <div className="buydopnft-modal">
            <div className="inner-text">
              <p>No. of NFTs</p>
              <h6>{totalNFT}</h6>
            </div>
            <div className="inner-text">
              <p>${Presale?.symbol} Price</p>
              <h6>${stakingData ? discountedPriceee?.toFixed(8) : price}</h6>
            </div>
            <div className="inner-text">
              <p>Total in {selectedToken}</p>
              <h6>
                {selectedToken === "USDT"
                  ? checkBoxx
                    ? parseFloat(
                        parseFloat(totalUsdt) + totalUsdt * insurancePer,
                      )?.toFixed(3)
                    : totalUsdt
                  : selectedToken === "ETH"
                    ? checkBoxx
                      ? parseFloat(
                          parseFloat(totalEth) + totalEth * insurancePer,
                        )?.toFixed(3)
                      : totalEth?.toFixed(3)
                    : selectedToken === "WETH"
                      ? checkBoxx
                        ? parseFloat(
                            parseFloat(totalWeth) + totalWeth * insurancePer,
                          )?.toFixed(3)
                        : totalWeth?.toFixed(3)
                      : selectedToken === "TOMI"
                        ? checkBoxx
                          ? parseFloat(
                              parseFloat(totalTomi) + totalTomi * insurancePer,
                            )?.toFixed(3)
                          : totalTomi?.toFixed(3)
                        : selectedToken === "USDC"
                          ? checkBoxx
                            ? parseFloat(
                                parseFloat(totalUsdc) +
                                  totalUsdc * insurancePer,
                              )?.toFixed(3)
                            : totalUsdc?.toFixed(3)
                          : selectedToken === "UNI"
                            ? checkBoxx
                              ? parseFloat(
                                  parseFloat(totalUni) +
                                    totalUni * insurancePer,
                                )?.toFixed(3)
                              : totalUni?.toFixed(3)
                            : selectedToken === "LINK"
                              ? checkBoxx
                                ? parseFloat(
                                    parseFloat(totalLink) +
                                      totalLink * insurancePer,
                                  )?.toFixed(3)
                                : totalLink?.toFixed(3)
                              : selectedToken === "PEPE"
                                ? checkBoxx
                                  ? parseFloat(
                                      parseFloat(totalPepe) +
                                        totalPepe * insurancePer,
                                    )?.toFixed(3)
                                  : totalPepe?.toFixed(3)
                                : selectedToken === "DOP"
                                  ? checkBoxx
                                    ? parseFloat(
                                        parseFloat(totalDop) +
                                          totalDop * insurancePer,
                                      )?.toFixed(3)
                                    : totalDop?.toFixed(3)
                                  : selectedToken === "WBTC"
                                    ? checkBoxx
                                      ? parseFloat(
                                          parseFloat(totalWbtc) +
                                            totalWbtc * insurancePer,
                                        )?.toFixed(3)
                                      : totalWbtc?.toFixed(3)
                                    : checkBoxx
                                      ? parseFloat(
                                          parseFloat(totalGems) +
                                            totalGems * insurancePer,
                                        )?.toFixed(3)
                                      : totalGems?.toFixed(3)}
              </h6>
            </div>
            <div className="inner-text">
              <p>Total Claimable ${Presale?.symbol}</p>
              <h6>
                {stakingData
                  ? (totall + totalClaim).toFixed(2)
                  : parseFloat(totalClaim)?.toFixed(4)}{" "}
                ${Presale?.symbol}
              </h6>
            </div>
          </div>
          <div className="twice-btnsss">
            <button onClick={handleClose1} className="btn-backkk">
              Back
            </button>

            <button onClick={submitt} className="btn-proceed ">
              proceed
            </button>
          </div>
        </Modal.Body>
      </Modal>

      <Modal
        className="connectwallet-modal buy-modal trx-modal"
        show={show2}
        onHide={handleClose2}
        centered
      >
        <Modal.Header closeButton>
          <Modal.Title>${Presale?.symbol} Purchased</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <div className="buy-modal">
            <img src="\assets\purchased.svg" alt="img" className="img-fluid" />
            <h4>Tokens Successfully Purchased</h4>
            <p>You have successfully purchased Tokens</p>
            <div className="token-purchased-area">
              <div className="single-value">
                <h5>Tokens Purchased</h5>
                <h6>
                  {stakingData
                    ? (totall + totalClaim).toFixed(2)
                    : parseFloat(totalClaim)?.toFixed(4)}{" "}
                  ${Presale?.symbol}
                </h6>
              </div>
            </div>
            <div className="token-purchased-area tokenpurchasedlast">
              {/* {checkBoxx && ( */}
              <div className="single-value">
                <h5>Token Purchase Amount</h5>
                <h6>
                  <span style={{ color: "#02171D", fontFamily: "f37" }}>
                    {selectedToken === "USDT"
                      ? totalUsdt
                      : selectedToken === "ETH"
                        ? totalEth?.toFixed(3)
                        : selectedToken === "WETH"
                          ? totalWeth?.toFixed(3)
                          : selectedToken === "TOMI"
                            ? totalTomi?.toFixed(3)
                            : selectedToken === "USDC"
                              ? totalUsdc?.toFixed(3)
                              : selectedToken === "UNI"
                                ? totalUni?.toFixed(3)
                                : selectedToken === "LINK"
                                  ? totalLink?.toFixed(3)
                                  : selectedToken === "PEPE"
                                    ? totalPepe?.toFixed(3)
                                    : selectedToken === "DOP"
                                      ? totalDop?.toFixed(3)
                                      : selectedToken === "WBTC"
                                        ? totalWbtc?.toFixed(3)
                                        : totalGems?.toFixed(3)}
                  </span>{" "}
                  <span style={{ color: "#02171D", fontFamily: "f37" }}>
                    {" "}
                    {selectedToken}
                  </span>{" "}
                  <span style={{ fontSize: "18px", color: "#77868B" }}>
                    ($
                    {check
                      ? nftPriceArryUsdt?.toLocaleString(undefined, {
                          minimumFractionDigits: 0,
                          maximumFractionDigits: 5,
                        })
                      : 0.0}
                    )
                  </span>
                </h6>
              </div>
              {/* )} */}
              {checkBoxx && (
                <div className="single-value">
                  <h5 style={{ color: "#329879" }}>Gems Protect</h5>
                  <h6>
                    {selectedToken === "USDT"
                      ? parseFloat(totalUsdt * insurancePer)?.toFixed(3)
                      : selectedToken === "ETH"
                        ? parseFloat(totalEth * insurancePer)?.toFixed(3)
                        : selectedToken === "WETH"
                          ? parseFloat(totalWeth * insurancePer)?.toFixed(3)
                          : selectedToken === "TOMI"
                            ? parseFloat(totalTomi * insurancePer)?.toFixed(3)
                            : selectedToken === "USDC"
                              ? parseFloat(totalUsdc * insurancePer)?.toFixed(3)
                              : selectedToken === "UNI"
                                ? parseFloat(totalUni * insurancePer)?.toFixed(
                                    3,
                                  )
                                : selectedToken === "LINK"
                                  ? parseFloat(
                                      totalLink * insurancePer,
                                    )?.toFixed(3)
                                  : selectedToken === "PEPE"
                                    ? parseFloat(
                                        totalPepe * insurancePer,
                                      )?.toFixed(3)
                                    : selectedToken === "DOP"
                                      ? parseFloat(
                                          totalDop * insurancePer,
                                        )?.toFixed(3)
                                      : selectedToken === "WBTC"
                                        ? parseFloat(
                                            totalWbtc * insurancePer,
                                          )?.toFixed(3)
                                        : parseFloat(
                                            totalGems * insurancePer,
                                          )?.toFixed(3)}{" "}
                    {selectedToken}{" "}
                    <span style={{ fontSize: "18px", color: "#77868B" }}>
                      ($
                      {check
                        ? (nftPriceArryUsdt * insurancePer)?.toLocaleString(
                            undefined,
                            {
                              minimumFractionDigits: 0,
                              maximumFractionDigits: 5,
                            },
                          )
                        : 0.0}
                      )
                    </span>
                  </h6>
                </div>
              )}
              <div className="single-value">
                <h5 style={{ color: "#329879" }}>
                  Total Spent (incl. network fees)
                </h5>
                <h6 style={{ fontFamily: "f37", color: "#329879" }}>
                  {selectedToken === "USDT"
                    ? checkBoxx
                      ? parseFloat(
                          parseFloat(totalUsdt) + totalUsdt * insurancePer,
                        )?.toFixed(3)
                      : totalUsdt
                    : selectedToken === "ETH"
                      ? checkBoxx
                        ? parseFloat(
                            parseFloat(totalEth) + totalEth * insurancePer,
                          )?.toFixed(3)
                        : totalEth?.toFixed(3)
                      : selectedToken === "WETH"
                        ? checkBoxx
                          ? parseFloat(
                              parseFloat(totalWeth) + totalWeth * insurancePer,
                            )?.toFixed(3)
                          : totalWeth?.toFixed(3)
                        : selectedToken === "TOMI"
                          ? checkBoxx
                            ? parseFloat(
                                parseFloat(totalTomi) +
                                  totalTomi * insurancePer,
                              )?.toFixed(3)
                            : totalTomi?.toFixed(3)
                          : selectedToken === "USDC"
                            ? checkBoxx
                              ? parseFloat(
                                  parseFloat(totalUsdc) +
                                    totalUsdc * insurancePer,
                                )?.toFixed(3)
                              : totalUsdc?.toFixed(3)
                            : selectedToken === "UNI"
                              ? checkBoxx
                                ? parseFloat(
                                    parseFloat(totalUni) +
                                      totalUni * insurancePer,
                                  )?.toFixed(3)
                                : totalUni?.toFixed(3)
                              : selectedToken === "LINK"
                                ? checkBoxx
                                  ? parseFloat(
                                      parseFloat(totalLink) +
                                        totalLink * insurancePer,
                                    )?.toFixed(3)
                                  : totalLink?.toFixed(3)
                                : selectedToken === "PEPE"
                                  ? checkBoxx
                                    ? parseFloat(
                                        parseFloat(totalPepe) +
                                          totalPepe * insurancePer,
                                      )?.toFixed(3)
                                    : totalPepe?.toFixed(3)
                                  : selectedToken === "DOP"
                                    ? checkBoxx
                                      ? parseFloat(
                                          parseFloat(totalDop) +
                                            totalDop * insurancePer,
                                        )?.toFixed(3)
                                      : totalDop?.toFixed(3)
                                    : selectedToken === "WBTC"
                                      ? checkBoxx
                                        ? parseFloat(
                                            parseFloat(totalWbtc) +
                                              totalWbtc * insurancePer,
                                          )?.toFixed(3)
                                        : totalWbtc?.toFixed(3)
                                      : checkBoxx
                                        ? parseFloat(
                                            parseFloat(totalGems) +
                                              totalGems * insurancePer,
                                          )?.toFixed(3)
                                        : totalGems?.toFixed(3)}{" "}
                  {selectedToken}{" "}
                  <span style={{ fontSize: "18px", color: "#77868B" }}>
                    ($
                    {check ? (
                      <>
                        {checkBoxx
                          ? (
                              nftPriceArryUsdt +
                              nftPriceArryUsdt * insurancePer +
                              buyingNetworkFee
                            )?.toLocaleString(undefined, {
                              minimumFractionDigits: 0,
                              maximumFractionDigits: 5,
                            })
                          : (
                              nftPriceArryUsdt + buyingNetworkFee
                            )?.toLocaleString(undefined, {
                              minimumFractionDigits: 0,
                              maximumFractionDigits: 5,
                            })}
                      </>
                    ) : (
                      0.0
                    )}
                    )
                  </span>
                </h6>
              </div>
            </div>

            <button
              className="btn-common"
              onClick={() => {
                handleClose2();
              }}
              style={{ marginTop: "20px" }}
            >
              Okay
            </button>
          </div>
        </Modal.Body>
      </Modal>
    </>
  );
};

export default DopNft;
